module.exports = __webpack_public_path__ + "media/agent_2_yureru_s.6b70dc4e.mp3";